import styled from '@emotion/styled'

export const List = styled.ul`
  margin: 0 0 10px 0;
  list-style-type: none;
  padding: 0;
  button {
    display: block;
    margin-bottom: 4px;
  }
`

export const ListItem = styled.li`
  height: 20px;
`

export const ListLabel = styled.label`
  font-weight: bold;
`
